import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';

import { Observable,Subject } from 'rxjs';


import { UserInfoService, LoginInfoInStorage} from './user-info.service';
import { ApiRequestService } from './api-request.service';



@Injectable()
export class PartnerService {
    constructor(
        private http: Http,
        private apiRequest: ApiRequestService
    ) {}

    getAllPartner(): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        let caseDataSubject = new Subject<any>(); // Will use this subject to emit data that we want

        this.apiRequest.get('partner/fetchAllPartnerNames')
            .subscribe(jsonResp => {
              
                let returnObj = jsonResp;
                 caseDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return caseDataSubject;
    }
     getAllPartnerBranch(partnerId:Number): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        let caseDataSubject = new Subject<any>(); // Will use this subject to emit data that we want

        this.apiRequest.get('partner/fetchBranchNames/'+partnerId)
            .subscribe(jsonResp => {
              
                let returnObj = jsonResp;
                 caseDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return caseDataSubject;
    }
   
     
   
}